import {
    AbacoWebModule,
    MenuItem,
    RouterReadyEvent,
    VueRouter,
    ApplicationReadyEvent
} from "@abaco/web-common/src/app";
import globals from "./globals";
import myRoutes from "./routes";
import { createMenu } from "./menu";
import FarmerRegistryModule from '@abaco/farm-registry/src/modules/farm-registry';
import MapWebModule from "@abaco/map-web-module/src/modules/map-web-module/index";
import { HTTPClient } from '@abaco/web-common/src/HTTP';
import GlobalState from "@abaco/portal-global-state/src/modules/global-state/index";
import DashboardModule from '@abaco/dashboard-module/src/modules/dashboard';
import UserModule from '@abaco/user-module/src/modules/user-module';
import CropPlanModule from '@abaco/crop-plan-module/src/modules/crop-plan-module';
import DashboardChartsModule from '@abaco/dashboard-module/src/modules/charts';
import GrapesDashboardVuexModule from './state';
import GrapesApi from './api/GrapesApi';
import VarietiesApi from './api/VarietiesApi';
import NotificationsApi from './api/NotificationsApi';
import ShortcutsApi from './api/ShortcutsApi';
import IndexesApi from './api/IndexesApi';
import ChartsApi from './api/ChartsApi';
import CostConsumptionApi from './api/CostConsumptionApi';
import SatellitesApi from './api/SatellitesApi';
import Vue from "vue";
import { HA_UNIT } from "@abaco/crop-plan-module/src/modules/crop-plan-module/api/utils";
import NumberUtils from "@abaco/web-components/src/components/input/NumberUtils"
import VineyarApi from "./api/VineyarApi";
import SfeProdApi from "./api/SfeProdApi";

const rootPath = "/sitiagri-rest-api/api_basic";
const siticatastoApi = "/siticatasto/dbgis-servlet";
const grapeRootApi = "/indexes/api";

const state = new GrapesDashboardVuexModule();

export const MODULE_ID = "grapes_dashboard_module";
export default class GrapesDashboardModule implements AbacoWebModule {
    public static MODULE_ID = MODULE_ID;

    private router!: VueRouter;

    private apiCreated = false;
    private grApi!: GrapesApi;
    private notApi!: NotificationsApi;
    private shApi!: ShortcutsApi;
    private varApi!: VarietiesApi;
    private indApi!: IndexesApi;
    private chrtApi!: ChartsApi;
    private costConsApi!: CostConsumptionApi;

    private satApi!: SatellitesApi;
    private vinrApi!: VineyarApi;
    private sfePrd!: SfeProdApi;

    readonly vuexModule = state;

    readonly id = MODULE_ID;
    readonly routes = myRoutes;
    readonly globalComponents = globals;
    menu: MenuItem[] = [];

    public dangerLimit = 40;
    public warningLimit = 60;

    onRouterReady(evt: RouterReadyEvent) {
        this.router = evt.router;
        this.menu = createMenu(this.router);

        Vue.filter("TO_AREA_HA", (val: number, fromFormat?: string) => {
            if (fromFormat === HA_UNIT) {
                return NumberUtils.stringify(val, 4)
            }
            return NumberUtils.stringify(val / 10000, 4)
        })

    }

    async beforeEnterAnyRoutes(http: HTTPClient) {
        if (this.apiCreated) {
            return;
        }
        this.apiCreated = true;

        const GrapesApi = (await import("./api/GrapesApi")).default;
        this.grApi = new GrapesApi(http);

        const NotificationsApi = (await import("./api/NotificationsApi")).default;
        this.notApi = new NotificationsApi(http);

        const ShortcutsApi = (await import("./api/ShortcutsApi")).default;
        this.shApi = new ShortcutsApi(http);

        const VarietiesApi = (await import("./api/VarietiesApi")).default;
        this.varApi = new VarietiesApi(http);

        const IndexesApi = (await import("./api/IndexesApi")).default;
        this.indApi = new IndexesApi(http);

        const ChartsApi = (await import("./api/ChartsApi")).default;
        this.chrtApi = new ChartsApi(http);

        const CostConsumptionApi = (await import("./api/CostConsumptionApi")).default;
        this.costConsApi = new CostConsumptionApi(http);

        const SatellitesApi = (await import("./api/SatellitesApi")).default;
        this.satApi =  new SatellitesApi(http, siticatastoApi);

        const VineyarApi = (await import("./api/VineyarApi")).default;
        this.vinrApi = new VineyarApi(http, grapeRootApi);

        const SfeProdApi = (await import("./api/SfeProdApi")).default;
        this.sfePrd = new SfeProdApi(http, grapeRootApi);
    }

    get grapesApi() {
        return this.grApi;
    }

    get notificationsApi() {
        return this.notApi;
    }

    get shortcutsApi() {
        return this.shApi;
    }

    get varietiesApi() {
        return this.varApi;
    }

    get indexesApi() {
        return this.indApi;
    }

    get chartsApi() {
        return this.chrtApi;
    }

    get costConsumptionApi() {
        return this.costConsApi;
    }

    get satellitesApi() {
        return this.satApi;
    }

    get vineyarApi() {
        return this.vinrApi;
    }

    get sfeProdApi() {
        return this.sfePrd;
    }

    dependsOn = {
        [MapWebModule.MODULE_ID]: () => new MapWebModule(),
        [FarmerRegistryModule.MODULE_ID]: () => new FarmerRegistryModule(),
        [GlobalState.MODULE_ID]: () => new GlobalState(),
        [DashboardModule.MODULE_ID]: () => new DashboardModule(),
        [DashboardChartsModule.MODULE_ID]: () => new DashboardChartsModule(),
        [UserModule.MODULE_ID]: () => new UserModule(),
        [CropPlanModule.MODULE_ID]: () => new CropPlanModule(),
    }

}
